import styles from "./Counter.module.css";
import CounterItem from "./CounterItem";

export default function Counter({ counters }) {
  return (
    <div className={styles.counterBox}>
      <div className={styles.counter}>
        {counters.map(counter => (
          <CounterItem key={`counters-${counter.id}`} {...counter} />
        ))}
      </div>
    </div>
  );
}
